module.exports = __webpack_public_path__ + "static/covid-intro-fade-f740166987a377fb48b3cb5a3616ac20.mp4";